import { Provider } from 'mobx-react';
import * as React from 'react';
import { HashRouter, Route, Switch } from 'react-router-dom';
import { modalStore } from 'ws-react-modal-dialog';
import { DynamicImport, NotFound } from 'ws-voice-infinity-global-module/lib/components';
import { authStore, eventStore, globalStore, mainPageStore, messageStationStore, notificationStore, oktmoStore, subscriptionStore, userStore } from 'ws-voice-infinity-global-module/lib/store';
import complaintMetricStore from '../modules/Global/stores/complaintMetricStore';
import MainWrap from '../modules/Wrappers/mainWrap/mainWrapComponent';

const stores = { authStore, globalStore, mainPageStore, messageStationStore, oktmoStore, userStore, notificationStore, modalStore, eventStore, complaintMetricStore, subscriptionStore };

export default class MainRouter extends React.Component<{
    history?: any;
    location?: any;
}> {
    render() {
        return (
            <Provider
                {...stores}
            >
                <HashRouter>
                    <Switch>
                        <MainWrap
                            location={this.props.location}
                        >
                            <Switch>
                                <Route
                                    exact
                                    path="/"
                                    component={(props: any) => <DynamicImport
                                        load={() => import('../modules/OnlineReception/pages/mainPage/mainPageComponent')}
                                        propsParent={props}
                                    />}
                                />
                                <Route
                                    exact
                                    path="/new/:complaintSubjectId?"
                                    component={(props: any) => <DynamicImport
                                        load={() => import('../modules/OnlineReception/pages/complaintCreate/complaintCreateContainer')}
                                        propsParent={props}
                                    />}
                                />
                                <Route
                                    exact
                                    path="/cabinet"
                                    component={(props: any) => <DynamicImport
                                        load={() => import('../modules/Cabinet/pages/cabinetComplaintMain/cabinetComplaintMainContainer')}
                                        propsParent={props}
                                    />}
                                />
                                <Route
                                    exact
                                    path="/cabinet/:complaintsType"
                                    component={(props: any) => <DynamicImport
                                        load={() => import('../modules/Cabinet/pages/cabinetComplaintsList/cabinetComplaintListContainer')}
                                        propsParent={props}
                                    />}
                                />
                                <Route
                                    exact
                                    path="/cabinet/messages/:id/edit"
                                    component={(props: any) => <DynamicImport
                                        load={() => import('../modules/OnlineReception/pages/complaintEdit/complaintEditContainer')}
                                        propsParent={props}
                                    />}
                                />
                                <Route
                                    exact
                                    path="/cabinet/messages/:id"
                                    component={(props: any) => <DynamicImport
                                        load={() => import('../modules/Cabinet/pages/cabinetComplaintCard/cabinetComplaintCardContainer')}
                                        propsParent={props}
                                    />}
                                />
                                <Route
                                    exact
                                    path={'/subject-category/:id?'}
                                    component={(props: any) => <DynamicImport
                                        load={() => import('../modules/OnlineReception/pages/subjectsCatalog/subjectsCatalogContainer')}
                                        propsParent={props}
                                    />}
                                />
                                <Route
                                    component={NotFound}
                                />
                            </Switch>
                        </MainWrap>
                        <Route
                            component={NotFound}
                        />
                    </Switch>
                </HashRouter>
            </Provider>
        );
    }
}
